import React from "react";
import moment from "moment";
import { IonCol, IonSpinner } from "@ionic/react";
import { numberWithCommas } from "helpers/helper";
import Cross from "assets/images/icon/svg/Cross";

export default function RevenueTable({
  loading,
  revenueData,
  totalAmount,
  getDate,
  dateFormat,
  currency,
  notFoundText,
  filterClicked,
  handleCrossFilter,
}) {
  const headers = revenueData[0] ? Object?.keys(revenueData[0]) : [];

  return (
    <div className={`${!filterClicked ? "mt-10" : "mt-3"} px-4`}>
      <div className={`${!filterClicked && "pt-3"}`}>
        <div className="flex items-center py-4">
          <h4 className="font-bold text-16 text-black-1000">
            Revenue on
            <span>
              {moment(getDate?.start, "YYYY-MM-DD").format(dateFormat)} -{" "}
              {moment(getDate?.end, "YYYY-MM-DD").format(dateFormat)}
            </span>
          </h4>
          {filterClicked && (
            <div
              onClick={handleCrossFilter}
              className="ml-1 p-1 bg-white border rounded-full shadow-xl cursor-pointer"
            >
              <Cross color={"black"} />
            </div>
          )}
        </div>

        <div className="flex justify-between items-center pb-5">
          <h4 className="font-bold text-16 text-black-1000">
            Total Amount: {currency}
            {numberWithCommas(totalAmount)}
          </h4>
        </div>
        <div>
          {loading ? (
            <div className="flex items-center justify-center h-[156px] m-auto">
              <IonSpinner name="crescent" />
            </div>
          ) : revenueData.length ? (
            <div className="overflow-x-auto">
              <table
                className="table-auto w-full bg-white"
                style={{
                  boxShadow: "0px 3px 20px 0px rgba(0, 0, 0, 0.05)",
                }}
              >
                <thead>
                  <tr className="border h-[45px] border-r-0 border-l-0 border-D9D9D9 px-4">
                    {headers.map((header) => (
                      <th
                        key={header}
                        className="border p-1 font-bold text-12 min-w-[100px] capitalize"
                      >
                        {header}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {revenueData.map((row, index) => (
                    <tr
                      key={index}
                      className="text-center h-[34px] border border-r-0 border-l-0 border-D9D9D9 px-4 cursor-pointer"
                    >
                      {headers.map((key) => (
                        <td
                          key={key}
                          className="border p-2 font-semibold text-10"
                        >
                          {key === "date" ? (
                            <span className="font-bold">
                              {moment(row[key]).format(dateFormat)}
                            </span>
                          ) : (
                            <>
                              {currency}
                              {numberWithCommas(row[key])}
                            </>
                          )}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <IonCol size="12">
              <div
                className="text-center flex items-center justify-center"
                style={{ height: "calc(100vh - 420px)" }}
              >
                <div>
                  <img
                    className="m-auto mb-[10px] mt-5"
                    src="/assets/images/not-found-file.png"
                    alt="emptyCard"
                  />
                  <p className="text-16 font-normal text-222222 mb-[35px]">
                    {notFoundText}
                  </p>
                </div>
              </div>
            </IonCol>
          )}
        </div>
      </div>
    </div>
  );
}
